import React from "react";
import styled from "styled-components";
import { IoClose } from "react-icons/io5";

interface MessageProps {
  data: { message: string; type: string } | undefined;
  close: () => void;
}
const Message = (props: MessageProps) => {
  const { data, close } = props;
  return !!data?.message ? (
    <Container type={data.type}>
      <CloseButton messageType={data.type} onClick={close}>
        <IoClose />
      </CloseButton>
      <Text type={data.type}>{data?.message}</Text>
    </Container>
  ) : null;
};

export default Message;

const Container = styled.div<{ type: string }>`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background-color: ${(props) =>
    props.type === "error" ? "#f8d7da" : "#d1e7dd"};
  color: ${(props) => (props.type === "error" ? "#842029" : "#0f5132")};
  padding: 1rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid ${(props) =>
    props.type === "error" ? "#f1aeb5" : "#a3cfbb"};
  border-radius: 0.375rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease-in-out;
  position: relative;
`;

const Text = styled.div<{ type: string }>`
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  flex: 1;
  padding-right: 0.75rem;
`;

const CloseButton = styled.button.attrs<{ messageType: string }>((props) => ({
  type: 'button'
}))<{ messageType: string }>`
  background: none;
  border: none;
  padding: 0.25rem;
  margin-left: 0.5rem;
  font-size: 1.25rem;
  color: ${(props) => (props.messageType === "error" ? "#842029" : "#0f5132")};
  cursor: pointer;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  position: absolute;
  top: 0.25rem;
  right: 0.5rem;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
    transform: scale(1.1);
  }
  
  &:focus {
    outline: 2px solid ${(props) =>
      props.messageType === "error" ? "#842029" : "#0f5132"};
    outline-offset: 2px;
  }
`;
